import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaMountain, FaStar } from 'react-icons/fa';
import { trekkingTours } from '../data/tourData';
import './TrekkingTours.css';

const TrekkingTours = () => {
  return (
    <>
      <Helmet>
        <title>Trekking Tours - NomadTrailz</title>
        <meta name="description" content="Explore our collection of trekking tours across the Himalayas. From easy day treks to challenging multi-day adventures." />
      </Helmet>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="trekking-tours-hero">
          <div className="container">
            <motion.h1 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Trekking Tours
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Discover the thrill of mountain trekking with our carefully curated collection of adventures
            </motion.p>
          </div>
        </div>

        <div className="trekking-tours-content">
          <div className="container">
            <div className="tours-grid">
              {trekkingTours.map((tour, index) => (
                <motion.div
                  key={tour.id}
                  className="tour-card"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ y: -10 }}
                >
                  <Link to={tour.link} className="tour-card-link">
                    <div className="tour-image">
                      <img src={tour.image} alt={tour.name} />
                      <div className="tour-duration">{tour.duration}</div>
                    </div>
                    <div className="tour-content">
                      <h3>{tour.name}</h3>
                      <div className="tour-highlights">
                        <span>
                          <FaMountain />
                          {tour.altitude}
                        </span>
                        <span>
                          <FaStar />
                          {tour.difficulty}
                        </span>
                      </div>
                      <div className="tour-price">
                        <span className="price-label">Starting From</span>
                        <span className="price">{tour.price}</span>
                      </div>
                      <div className="book-btn">View Details</div>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default TrekkingTours;
